import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { formatUSD } from "@/shared/utils/ultils";
import { socket } from "@/shared/config/socket";

const ListGiaPC = () => {
  const [listHangHoa, setListHangHoa] = useState<any>([]);
  useEffect(() => {
    socket.on("get_prices", (data: any) => {
      setListHangHoa(data);
    });
  }, []);

  return (
    <div>
      <Marquee>
        <div className="d-flex gap-2 ms-3">
          {listHangHoa?.map((item: any, index: number) => {
            return (
              <div className="d-flex gap-2 align-items-center" key={index}>
                <div className="text-white d-flex gap-1 align-items-center">
                  <img
                    width={25}
                    height={25}
                    className="rounded-circle"
                    src={
                      `https://faofood.com/assets/images/commodity/` +
                      item?.image
                    }
                  />
                  {item?.name} ({item?.code})
                </div>
                <div style={{ width: 120 }}>
                  <span style={{ color: "hsl(49 92% 54%)" }}>
                    {formatUSD(item?.price)}
                  </span>
                  <span
                    className="ps-1"
                    style={{
                      color:
                        item?.twenty_four_hour_change > 0
                          ? "hsl(152 69% 31%)"
                          : "hsl(354 70% 54%)",
                      fontSize: 13,
                    }}
                  >
                    {item?.twenty_four_hour_change}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </Marquee>
    </div>
  );
};

export default ListGiaPC;
